"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Search_1 = __importDefault(require("./Search"));
class Index {
    constructor(parent, entryId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.entryId = entryId;
    }
    path(withParameter = true) {
        if (withParameter && this.entryId !== null) {
            return `${this.parent.path()}/entries/${this.entryId}`;
        }
        return `${this.parent.path()}/entries`;
    }
    /**
     * Returns contact information on corporate users of federated accounts. Please note: 1. `User`, `DigitalUser`, `VirtualUser` and `FaxUser` types are returned as `User` type. 2. `ApplicationExtension` type is not returned. 3. Only extensions in `Enabled`, `Disabled` and `NotActivated` state are returned.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/directory/entries
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Returns contact information on a particular corporate user of a federated account.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/directory/entries/{entryId}
     * Rate Limit Group: Medium
     * App Permission: ReadAccounts
     */
    async get(restRequestConfig) {
        if (this.entryId === null) {
            throw new Error('entryId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    search() {
        return new Search_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map